export function getDiffPrompt(intervieweeResponse: string, idealResponse: string) {
  const prompt = `
**Interviewee's Response**
${intervieweeResponse}

**Ideal Response:**
${idealResponse}

#### Guidelines
Identify and select the sentences or parts of sentences in the ideal response that are NOT covered by the interviewee's response. Ensure the selected text matches the ideal response precisely. Consider the meaning and intent behind each sentence when comparing the responses, even if the wording is not identical.
`;

  return prompt;
}
